import { Box3, Vector3 } from 'three';

export function getContainerBox(root) {
  const box = new Box3();
  box.expandByObject(root);
  return box;
}

export function getObjectSize(object) {
  const size = new Vector3();
  getContainerBox(object).getSize(size);
  return size;
}

export function getGeometrySize(object) {
  const size = new Vector3();
  object.geometry.computeBoundingBox();
  object.geometry.boundingBox.getSize(size);
  return size;
}

export function getGeometryBox(object) {
  const box = new Box3();
  object.geometry.computeBoundingBox();
  box.copy(object.geometry.boundingBox);
  object.updateWorldMatrix(true, true);
  box.applyMatrix4(object.matrixWorld);
  return box;
}
